import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { ColumnsToHide, DetailRow } from '../../ag-grid.component';

interface CustomCellRendererParams extends ICellRendererParams {
  onload?: (param1) => void;
  subTableEdited?: (param1) => void;
  changeFieldControl: Subject<ColDef>;
  genericDetailRowConfig: DetailRow;
  columnsChanged: () => ColumnsToHide[]
  
}

@Component({
  selector: 'full-width-renderer',
  templateUrl: './detail-row.component.html',
  styleUrls: ['./detail-row.component.scss']
  ,
})
export class DetailRowComponent implements ICellRendererAngularComp {
  params!: CustomCellRendererParams;
  detailConfig!: DetailRow;
  agInit(params: any): void {
    this.params = params;
    const detailConfigFromGrid =
      this.params?.context?.genericDetailRowConfig ||
      this.params?.genericDetailRowConfig;
    if (detailConfigFromGrid) {
      this.detailConfig = detailConfigFromGrid;

    }
  }

  refresh(params: any): boolean {
    return false
  }
}
